/**
 * TW screens.
 */

// Mobile-first screens.
// Using `(min-width: WIDTH)` media query
export const mobileFirstScreens = {
  xs: {
    min: 480,
  },
  sm: {
    min: 375,
  },
  md: {
    min: 768,
  },
  lg: {
    min: 1024,
  },
  narrative: {
    min: 1115,
  },
  xl: {
    min: 1440,
  },
} as const

export type MobileFirstScreenNames = keyof typeof mobileFirstScreens

// Desktop-first screens.
// Using `(max-width: WIDTH)` media query
const desktopFirstScreens = {
  'sm-max': {
    max: mobileFirstScreens.md.min - 1,
  },
  'md-max': {
    max: mobileFirstScreens.lg.min - 1,
  },
  'lg-max': {
    max: mobileFirstScreens.xl.min - 1,
  },
}

export type DesktopFirstScreenNames = keyof typeof desktopFirstScreens

// Exclusive screens
// Using `(min-width: WIDTH) and (max-width: WIDTH)` media query
const exclusiveScreens = {
  'md-only': {
    ...mobileFirstScreens.md,
    ...desktopFirstScreens['md-max'],
  },
  'lg-only': {
    ...mobileFirstScreens.lg,
    ...desktopFirstScreens['lg-max'],
  },
}

export type ExclusiveFirstScreenNames = keyof typeof exclusiveScreens

export type ScreenNames =
  | MobileFirstScreenNames
  | DesktopFirstScreenNames
  | ExclusiveFirstScreenNames

export type ScreenSettings = { min?: number; max?: number }

export type ScreenConfig = Record<ScreenNames, ScreenSettings>

const screens: ScreenConfig = {
  ...mobileFirstScreens,
  ...desktopFirstScreens,
  ...exclusiveScreens,
}

export const screenNames = Object.keys(screens)

export default screens
